import React from "react"

function CTA() {
  return (
    <span id="cta">
      <a className="cta-link call" href="tel:1-800-338-1949"><i className="fa fa-phone"> </i><span
        className="sr-only">Call Now</span></a>
      <a className="cta-link quote" href="https://www.commusa.com/contact-us"><i
      className="fa fa-envelope"> </i><span className="sr-only">Request Quote</span></a>
      <a className="cta-link to-top" href="#top"><i className="fa fa-arrow-up"> </i><span className="sr-only">Back Top Top</span></a>
    </span>
  )
}

export default CTA
